import React from 'react'
import { Text } from '@amzn/storm-ui'
import { EmptyResultsContainer } from 'views/manage/components/manage_shared.styles'

interface TableLoadErrorProps {
  errorBodyLabel: string
  errorHeaderLabel: string
  errorCallToAction: string
}

export const TableLoadErrorBody: React.FunctionComponent<TableLoadErrorProps> = (props: TableLoadErrorProps): JSX.Element => {
  const { errorBodyLabel, errorHeaderLabel, errorCallToAction } = props

  return (
    <EmptyResultsContainer>
      <Text type={'h3'} withMargin>
        {errorHeaderLabel}
      </Text>
      <Text>{errorBodyLabel}</Text>
      <Text>{errorCallToAction}</Text>
    </EmptyResultsContainer>
  )
}
